export default __webpack_public_path__ + "static/media/GR00010-ink_drip.f0887697.svg";